//
export default [
    {
        text        : 'sucursal',
        align       : 'left',
        sortable    : false,
        value       : 'name',
    },
    {
        text        : 'mínimo stock',
        align       : 'left',
        sortable    : false,
        value       : 'minimum_stock',
        editable    : true,
        fieldType   : 'text',
        width       : '200px',
    },
    {
        text        : 'máximo stock',
        align       : 'left',
        sortable    : false,
        value       : 'maximum_stock',
        editable    : true,
        fieldType   : 'text',
        width       : '200px',
    },
    {
        text        : 'stock critico',
        align       : 'left',
        sortable    : false,
        value       : 'critical_stock',
        editable    : true,
        fieldType   : 'text',
        width       : '200px',
    },
]
